import { IkeToken } from '@ikegps/core-api';
import { MaterialIcon } from '../../components/icon/icons';
import { T } from '../../i18n';
import { type IkeExternalLinkConfig, IkePageName } from '../page';

export const ComEdEsriPageConfig: IkeExternalLinkConfig = {
	type: 'external',
	name: IkePageName.comedEsri,
	path: 'https://ikegps.maps.arcgis.com/apps/instant/basic/index.html?appid=5d2823ffa29945bc9dc48b296c0934e6',
	auth: {
		required: true,
		tokens: [IkeToken.FEATURE_COMED_MAP_LINK],
	},
	layout: { banner: false },
	nav: {
		name: T.MULTI_ORG_MAP,
		icon: MaterialIcon.PUBLIC,
	},
};
